import { render, staticRenderFns } from "./zodiac-carousel.vue?vue&type=template&id=5bde7e4d&scoped=true"
import script from "./zodiac-carousel.vue?vue&type=script&lang=js"
export * from "./zodiac-carousel.vue?vue&type=script&lang=js"
import style0 from "./zodiac-carousel.vue?vue&type=style&index=0&id=5bde7e4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bde7e4d",
  null
  
)

export default component.exports